var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hasStatus)?_c('v-btn',{attrs:{"color":"secondary","text":"","loading":_vm.loading},on:{"click":function($event){return _vm.updateStatus()}}},[_vm._v("Update Status")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }